
    import { register } from "https://hfc-services-apps-stage.s3.us-west-1.amazonaws.com/content/latest/wc/ContentWebComponents.js";
    register();
  